import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // If on a protected page, redirect to login
      if (window.location.pathname !== '/login' &&
          window.location.pathname !== '/register' &&
          window.location.pathname !== '/forgot-password' &&
          window.location.pathname !== '/reset-password' &&
          !window.location.pathname.startsWith('/dr/') &&
          !window.location.pathname.startsWith('/terms/') &&
          !window.location.pathname.startsWith('/surgical-suite/login') &&
          !window.location.pathname.startsWith('/surgical-share/') &&
          window.location.pathname !== '/privacy' &&
          window.location.pathname !== '/brochure' &&
          window.location.pathname !== '/features' &&
          window.location.pathname !== '/') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(' ');
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
